import {
  normalizeBlockDocId,
  resolveClientBlockDocPath,
} from "../../../invitations/clientBlockPathResolver";

const toTrimmedLabel = (value) =>
  typeof value === "string" ? value.trim() : "";

export const normalizeFolderKey = (value) => toTrimmedLabel(value).toLowerCase();

export const isCrossFolderMove = (sourceFolderKey, targetFolderKey) =>
  normalizeFolderKey(sourceFolderKey) !== normalizeFolderKey(targetFolderKey);

export const getFolderTargetFromOver = (overData) => {
  if (!overData || overData.type !== "folderDropTarget") return null;
  if (typeof overData.folderKey !== "string") return null;
  return overData.folderKey;
};

export const getPersistedFolderLabelForSection = (section) => {
  if (!section) return "";

  const firstBlockWithLabel = Array.isArray(section.blocks)
    ? section.blocks.find((block) => typeof block?.label === "string")
    : null;

  return toTrimmedLabel(firstBlockWithLabel?.label);
};

export const getLowercaseBlockDocId = (blockId) =>
  normalizeBlockDocId(blockId);

export const buildBlockFolderMoveWritePlan = ({ client, blockId, targetLabel }) => {
  const blockDocPath = resolveClientBlockDocPath(client, blockId);
  if (!blockDocPath) return null;

  return {
    blockDocPathSegments: blockDocPath.pathSegments,
    label: toTrimmedLabel(targetLabel),
  };
};

const setClientAvoidTransaction = (client, value) => {
  if (!client) return;

  if (typeof client.setProperty === "function") {
    client.setProperty("avoidTransaction", value);
    return;
  }

  client.avoidTransaction = value;
};

const setBlockLabel = (block, label) => {
  if (!block) return;

  if (typeof block.setProperty === "function") {
    block.setProperty("label", label);
    return;
  }

  block.label = label;
};

export const applyOptimisticBlockLabel = ({ block, client, nextLabel }) => {
  if (!block) return () => {};

  const previousLabel = toTrimmedLabel(block?.label);
  const safeNextLabel = toTrimmedLabel(nextLabel);
  const previousAvoidTransaction = client?.avoidTransaction;

  setClientAvoidTransaction(client, true);
  try {
    setBlockLabel(block, safeNextLabel);
  } finally {
    setClientAvoidTransaction(client, previousAvoidTransaction);
  }

  return () => {
    setClientAvoidTransaction(client, true);
    try {
      setBlockLabel(block, previousLabel);
    } finally {
      setClientAvoidTransaction(client, previousAvoidTransaction);
    }
  };
};
